import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { Card, Grid, makeStyles, Typography } from '@material-ui/core';
import SVG from 'react-inlinesvg';

import { toAbsoluteUrl } from '../../../../_metronic/_helpers';

export function Users() {
	const { totals } = useSelector((state) => state.dashboard, shallowEqual);

	const classes = useStyles();

	return (
		<Card className={classes.container}>
			<Grid container justify='space-between' alignItems='center'>
				<div className='d-flex align-items-center'>
					<span className='symbol symbol-circle symbol-50 symbol-light mr-2'>
						<span className='symbol-label'>
							<span className='svg-icon svg-icon-lg svg-icon-dark'>
								<SVG src={toAbsoluteUrl('/assets/users.svg')}></SVG>
							</span>
						</span>
					</span>
					<div className='d-flex flex-column' style={{ marginLeft: 4 }}>
						<span className={classes.title}>Users</span>
						<Typography className={classes.score}>{totals?.Users || 0} total users</Typography>
					</div>
				</div>
			</Grid>
			<Grid container justify='space-between' alignItems='center' className='mt-3'>
				<Typography className={classes.subTitle}>New Signed Users</Typography>
				<div className='d-flex align-items-center'>
					<Typography className={classes.subContent}>{totals?.usersByType?.signed || 0}</Typography>
				</div>
			</Grid>
			<Grid container justify='space-between' alignItems='center' className='mt-3'>
				<Typography className={classes.subTitle}>New Guest Users</Typography>
				<div className='d-flex align-items-center'>
					<Typography className={classes.subContent}>{totals?.usersByType?.guest || 0}</Typography>
				</div>
			</Grid>
		</Card>
	);
}

const useStyles = makeStyles(() => ({
	container: {
		padding: 20,
		boxShadow: 'none !important',
		borderRadius: 10,
		height: '100%',
	},
	title: {
		fontSize: 16,
		color: '#353146',
		lineHeight: '16px',
	},
	score: {
		fontSize: 14,
		color: '#908BA4',
	},
	subTitle: {
		fontSize: 16,
		color: '#353146',
		lineHeight: '56px',
	},
	subContent: {
		color: '#0D0C12',
		fontSize: 20,
	},
	seeAllBtn: {
		cursor: 'pointer',
		color: '#353146',
	},
	avatar: {
		width: 40,
		height: 40,
		margin: 6,
	},
	improve: {
		marginLeft: 12,
		width: 40,
		textAlign: 'right',
	},
	users: {
		marginBottom: 16,
	},
}));
